import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

export const meNotificationsEmailStatus = createQueryFn(
  QueryNameSpace.meNotificationsEmailStatus,
  async () => {
    const res = await DigiobcanApi.meNotificationsEmailStatus();

    return res.status;
  },
);
